import type { ExternalToolBatchPayload } from '@terra/shared-dto-chat-types';
import type { OpenExternalToolBatchParams } from '../external-tool-batch.types';

export function openBatchParamsFromSsePayload(
  payload: ExternalToolBatchPayload,
): OpenExternalToolBatchParams {
  return {
    batchId: payload.batchId,
    chatId: payload.chatId,
    toolCallIds: payload.toolCallIds,
    toolName: payload.toolName,
    ...(payload.resumeGroupId ? { resumeGroupId: payload.resumeGroupId } : {}),
    ...(payload.toolNameByToolCallId
      ? { toolNameByToolCallId: payload.toolNameByToolCallId }
      : {}),
  };
}
